<template>
  <el-form-item label="文字加粗">
    <el-select v-model="optionModel.fontWeight" clearable>
      <el-option v-for="(item, idx) in weightList" :key="idx" :label="item" :value="item"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import i18n from "@/utils/i18n"

export default {
  name: "fontWeight-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object,
  },
  data() {
    return {
      weightList: ['bold', 'bolder', 'lighter', 'normal']
    }
  }
}
</script>

<style scoped></style>
